import React, { Component } from 'react'
import { injectIntl } from 'react-intl'         
import ElaborationType from './ElaborationType'
import { ElaborationOptionsMap, cutToSizeTypeMapInverted } from './CutToSizeMaps'
import Translation from '../global/Translation'
import LocalizedLink from "../global/LocalizedLink";
import ConfigurationFavoriteCallToAction from './configurable-favorites/configuration-favorite-call-to-action/ConfigurationFavoriteCallToAction'
import CustomProductsBannerCallToAction from './custom-products-banner-call-to-action/CustomProductsBannerCallToAction'

const getLinkProps = (elaboration) => {
    const option = ElaborationOptionsMap[elaboration]
    switch (elaboration) {
        case 'CTS_FLOOR_3D':
        case 'CTS_FLOOR':
            return {
                routeId: "ROUTE_CONFIG_CUT_TO_SIZE",
                params: { type: 'flooring', model: 'flooring', refcode: '', fabricator:'global' }
            }
        case 'CTS_CLADDING':
            return {
                routeId: "ROUTE_CONFIG_CUT_TO_SIZE",
                params: { type: 'cladding', model: 'cladding', refcode: '', fabricator:'global' }
            }
        default:
            return {
                routeId: 'ROUTE_CUT_TO_SIZE',
                header: true,
                queryString: `?type=${elaboration.toLowerCase()}`,
                params: {'outlet':''},
                // gtmLabel: option.gtmLabel
            }
    }
}

const excludedTypes = {
    BUDGET: true,
    CTS_SKIRTI: true,
    CTS_FURNIT: true,
}

class ElaborationTypeSelector extends Component {

    render () {
        const {materials} = this.props
        
        let matKeys = []
        if (materials) {
            matKeys = Object.keys(materials).filter(el => !excludedTypes[el])
        }

        return (
            <div name="cut_to_size_elaboration_type_selector">
                <div className="row no-gutters">
                    <h2 className="questa-bold title-cts">
                        <Translation id="custom_products" defaultMessage="Custom Products" />
                    </h2>
                </div>
                {
                    materials && (
                        <React.Fragment>
                            <div className="custom-products-block">
                                {
                                    matKeys.map(elaboration => {
                                        const elab = elaboration === 'CTS_FLOOR' ? 'CTS_FLOOR_3D' : elaboration
                                        const option = ElaborationOptionsMap[elab]
                                        const mappedType = cutToSizeTypeMapInverted[elab] || elaboration.toLowerCase()
                                        const linkProps = getLinkProps(elab)

                                        return (
                                            <div key={`id_${elaboration}`} className="custom-products-block__key">
                                                <LocalizedLink routeId={linkProps.routeId} header={true} queryString={`?type=${mappedType}`} params={linkProps.params} gtmLabel={option.gtmLabel}>
                                                    <ElaborationType
                                                        id={elaboration}
                                                        // brands={Object.keys(materials[elaboration])}
                                                        title={this.props.intl.formatMessage(option.name)}
                                                        icon={option.image}
                                                        description={this.props.intl.formatMessage(option.text)}
                                                    />
                                                </LocalizedLink>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className="cta-grid">
                                <ConfigurationFavoriteCallToAction />
                                <CustomProductsBannerCallToAction hasPreOrder={this.props.hasPreOrder} />
                            </div>
                        </React.Fragment>
                    )
                }
            </div>
        )
    }
}

export default injectIntl(ElaborationTypeSelector)